import { handleError } from "../../../util/errors";
import apiBase from "../../api";

class CommentsService {
  // Get comments for a device
  fetchComments = async (deviceId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append("page", params.page);
      if (params.perPage) queryParams.append("perPage", params.perPage);
      if (params.type) queryParams.append("type", params.type);

      const queryString = queryParams.toString();
      const url = `/comments/device/${deviceId}${queryString ? `?${queryString}` : ""}`;
      const response = await apiBase.get(url);
      if (response.status !== 200) throw new Error();
      // Response structure: { message, data: { data: [...], perPage, page, total } }
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching comments");
    }
  };

  // Get comment stats for a device
  fetchCommentStats = async (deviceId) => {
    try {
      const response = await apiBase.get(`/comments/device/${deviceId}/stats`);
      if (response.status !== 200) throw new Error();
      // Response structure: { message, data: { total, pinned, byType } }
      return response.data?.data || response.data;
    } catch (err) {
      throw handleError(err, "Error fetching comment stats");
    }
  };

  // Get single comment
  fetchComment = async (commentId) => {
    try {
      const response = await apiBase.get(`/comments/${commentId}`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error fetching comment");
    }
  };

  // Create comment
  createComment = async (deviceId, data) => {
    try {
      const response = await apiBase.post(`/comments/device/${deviceId}`, data);
      if (response.status !== 201 && response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error creating comment");
    }
  };

  // Update comment
  updateComment = async (commentId, data) => {
    try {
      const response = await apiBase.put(`/comments/${commentId}`, data);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error updating comment");
    }
  };

  // Delete comment
  deleteComment = async (commentId) => {
    try {
      const response = await apiBase.delete(`/comments/${commentId}`);
      if (response.status !== 200 && response.status !== 204) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error deleting comment");
    }
  };

  // Toggle pin status
  togglePin = async (commentId) => {
    try {
      const response = await apiBase.patch(`/comments/${commentId}/toggle-pin`);
      if (response.status !== 200) throw new Error();
      return response.data;
    } catch (err) {
      throw handleError(err, "Error toggling pin status");
    }
  };
}

export default new CommentsService();

